import { useState, useEffect } from 'react';

const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="11" cy="11" r="7" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);

export default function SearchBar({
  onSearch,
  loading,
  initialValue = '',
  size = 'compact',
  autoFocus = false,
  placeholder = '쿠팡 · 네이버 · 11번가 · 지마켓 통합 검색',
}) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const submit = (e) => {
    e.preventDefault();
    const q = value.trim();
    if (!q) return;
    onSearch(q);
  };

  return (
    <form className={`search-bar search-bar--${size}`} onSubmit={submit}>
      <span className="search-bar__icon">
        <SearchIcon />
      </span>
      <input
        className="search-bar__input"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        autoFocus={autoFocus}
      />
      <button className="search-bar__submit" type="submit" disabled={loading}>
        {loading ? '검색중' : '검색'}
      </button>
    </form>
  );
}
